import React, {Component} from 'react';
import {Redirect} from "react-router-dom";
import {getText} from './util/localization.js'
import {RETURN_URL} from "./GlobalConfiguration";

const queryString = require('query-string');
const localization = require('../localization/localization-goBackButton.json');


class GoBackButton extends Component {

    constructor(props) {
        super(props);

        let returnUrl = "";

        let queryStringParams = queryString.parse(props.location.search);
        if (queryStringParams.returnUrl !== undefined && queryStringParams.returnUrl !== '') {
            returnUrl = queryStringParams.returnUrl;
        }else{
            returnUrl = RETURN_URL;
        }

        this.state = {
            returnUrl: returnUrl
        };

        this.handleOnClick = this.handleOnClick.bind(this);
    }

    handleOnClick(e) {
        if (this.state.returnUrl === '') {
            window.close();
        }
        else {
            return <Redirect to={this.state.returnUrl}/>
        }

        e.preventDefault();
    }

    render() {
        return (<div className="container">
            <a className="btn btn-primary" href={this.state.returnUrl} role="button" onClick={this.handleOnClick}>{getText(localization.buttonSendText)}</a>
        </div>);
    }
}

export default GoBackButton;



// WEBPACK FOOTER //
// ./src/js/GoBackButton.js